import React from 'react';
import LocalizedStrings from 'react-localization';

function InsuranceFeatures(props) {
  const strings = new LocalizedStrings({
    ru: {
      title1: 'Оформление через',
      title2: 'POLIS.UA - это',
      txt1: 'Действует по всей территории страны',
      txt2: 'Полис действует по всей территории страны, оформление онлайн с любого города',
      txt3: 'Большой выбор по выгодной цене',
      txt4: 'Сотрудничаем только с лидерами страхового рынка. Все лучшие предложения от лучших страховых компаний в одном месте',
      txt5: 'Сэкономь 10% при оформлении',
      txt6: 'Моментальное оформление заявки для страховой компании. А при указании промокода, получите 10% скидки',
    },
    ua: {
      title1: 'Oформлення через',
      title2: 'POLIS.UA - це',
      txt1: 'Діє по всій території країни',
      txt2: 'Поліс діє по всій території країни, оформлення онлайн з будь-якого міста',
      txt3: 'Великий вибір за вигідною ціною',
      txt4: 'Співпрацюємо тільки з лідерами страхового ринку. Всі кращі пропозиції від кращих страхових компаній в одному місці',
      txt5: 'Заощаджуй 10% при оформленні',
      txt6: 'Моментальне оформлення заявки для страхової компанії. А при вказівці промокоду, отримаєте 10% знижки',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <div className="polis-about-block">
      <div className="title-block text-center"><h2>{strings.title1} <br />{strings.title2}</h2></div>
      <div className="row-scroll">
        <div className="row flex_j-space-between top">
          <div className="item">
            <h3>{strings.txt1}</h3>
            <p>{strings.txt2}</p>
          </div>
          <div className="item">
            <h3>{strings.txt3}</h3>
            <p>{strings.txt4}</p>
          </div>
          <div className="item">
            <h3>{strings.txt5}</h3>
            <p>{strings.txt6}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsuranceFeatures;
